import { Component, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Role } from '../models/role.model';
import { BuiltInFieldId } from '../models/built-in-field-id.enum';

@Component({
    template: ``,
    standalone: false
})
export abstract class BaseComponent implements OnDestroy {
	// Allow for use in all derived components.
	public roles = Role;
	public builtInFields = BuiltInFieldId;

	// Stream that signals a derived component is being destroyed. For use with takeUntil()
	protected destroy$: Observable<void>;

	private destroySource: Subject<void>;

	protected constructor() {
		this.destroySource = new Subject<void>();
		this.destroy$ = this.destroySource.asObservable();
	}

	ngOnDestroy(): void {
		this.destroySource.next();
	}

	public isDarkMode(): boolean {
		return localStorage['darkMode'] === 'true'
	}

	public openDocumentInDocumentViewer(documentId: string) {
		window.open(`/review/doc-viewer?DocId=${ documentId }`, 'DocViewer');
	}

}
